import React, { useState } from 'react';
import styles from './NewEvaluator.module.scss';
import AdminProjectList from '../../../../../../jobMatch/JobMatchList/AdminProjectList';
import UserSearch from '../../../../../../input/UserSearch/UserSearch';
import { Select } from '@tcc-online/input-components';
import { useTranslate } from 'react-translate.ts';
import { NumberSchema, ObjectSchema, StringSchema } from 'yup';
import Group from '../../../../../../../types/project/360/Group';

interface NewEvaluatorProps {
    groups: Group[];
    onCreate: (
        relationship: string,
        evaluatorId?: number,
        email?: string,
    ) => void;
}

interface Values {
    email?: string;
    id?: number;
    relationship?: string;
}

const validationSchema = new ObjectSchema({
    email: new StringSchema().email(),
    id: new NumberSchema(),
    relationship: new StringSchema().required().nonNullable(),
});

export default function NewEvaluator(props: NewEvaluatorProps) {
    const { onCreate, groups } = props;
    const [values, setValues] = useState<Values>({});
    const translate = useTranslate();

    return (
        <AdminProjectList.Row className={styles.row}>
            <UserSearch
                onChange={handleChange(values)}
                onCreate={handleCreate(values)}
            />
            <Select<Group>
                options={groups}
                getOptionValue={(option: Group) => option.id}
                getOptionLabel={(option: Group) => option.name}
                onChange={handleRelationshipChange(values)}
                label={translate('Skupina')}
            />
        </AdminProjectList.Row>
    );

    function handleChange(values: Values) {
        return async (params: { option: { id: number } }) => {
            const id = params.option.id;
            const newValues = { ...values, email: undefined, id };
            setValues(newValues);
            await create(newValues);
        };
    }

    function handleCreate(values: Values) {
        return async (email: string) => {
            const newValues = { ...values, email, id: undefined };
            setValues(newValues);
            await create(newValues);
        };
    }

    function handleRelationshipChange(values: Values) {
        return async (relationship: string) => {
            const newValues = { ...values, relationship };
            setValues(newValues);
            await create(newValues);
        };
    }

    async function create(values: Values) {
        if (await validate(values)) {
            onCreate(values.relationship as string, values.id, values.email);
        }
    }

    async function validate(values: Values) {
        return await validationSchema.validate(values);
    }
}
